if (!customElements.get('product-recommendations')) {
  class ProductRecommendations extends HTMLElement {
    connectedCallback() {
      if (this.dataset.wubRecommendationsReady === 'true') return;
      this.dataset.wubRecommendationsReady = 'true';

      if (this.innerHTML.trim().length) {
        this.classList.add('product-recommendations--loaded');
        return;
      }

      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver((entries) => {
          if (!entries.some((entry) => entry.isIntersecting)) return;
          this.observer.disconnect();
          this.fetchProducts();
        }, { rootMargin: '600px 0px' });
        this.observer.observe(this);
      } else {
        this.fetchProducts();
      }
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
      if (this.controller) this.controller.abort();
    }

    async fetchProducts() {
      if (!this.dataset.url || this.dataset.loading === 'true') return;
      this.dataset.loading = 'true';
      this.controller = new AbortController();

      try {
        const response = await fetch(this.dataset.url, {
          signal: this.controller.signal,
          headers: { 'X-Requested-With': 'XMLHttpRequest' }
        });
        if (!response.ok) throw new Error(`HTTP ${response.status}`);
        const text = await response.text();
        const html = new DOMParser().parseFromString(text, 'text/html');
        const recommendations = html.querySelector('product-recommendations');
        if (recommendations && recommendations.innerHTML.trim().length) {
          this.innerHTML = recommendations.innerHTML;
        }
        this.classList.add('product-recommendations--loaded');
      } catch (error) {
        if (error.name !== 'AbortError') console.error('[WUB recommendations]', error);
      } finally {
        delete this.dataset.loading;
      }
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);
}
